export default {
  "b2b.provozni-informace-form.field.image.label": "Image",
  "b2b.provozni-informace-form.field.title.label.cs": "Title in Czech",
  "b2b.provozni-informace-form.field.title.label.en": "Title in English",
  "b2b.provozni-informace-form.field.title.placeholder.cs":
    "Enter the title of the information in Czech",
  "b2b.provozni-informace-form.field.title.placeholder.en":
    "Enter the title of the information in English",
  "b2b.provozni-informace-form.field.description.label.cs":
    "Description in Czech",
  "b2b.provozni-informace-form.field.description.label.en":
    "Description in English",
  "b2b.provozni-informace-form.field.description.placeholder.cs":
    "Enter the description of the information in Czech",
  "b2b.provozni-informace-form.field.description.placeholder.en":
    "Enter the description of the information in English",
  "b2b.provozni-informace-form.field.content.label.cs": "Content in Czech",
  "b2b.provozni-informace-form.field.content.label.en": "Content in English",
  "b2b.provozni-informace-form.field.content.placeholder.cs":
    "Enter the content of the information in Czech",
  "b2b.provozni-informace-form.field.content.placeholder.en":
    "Enter the content of the information in English",
  "b2b.provozni-informace-form.field.attachments.label": "Attachments",
  "b2b.provozni-informace-form.button.submit": "Save",
  "b2b.provozni-informace-form.button.delete": "Delete",
  "b2b.provozni-informace-form.button.cancel": "Cancel",
  "b2b.provozni-informace-form.dialog.submit": "Saving operational information"
};
